import React, { useEffect, useState } from 'react'
import CompactGroups from '../CompactGroups'
import CompactEmployees from '../CompactEmployees'
import {ReactComponent as SyncIcon} from 'assets/images/icons/refresh.svg'
import { createBenefits } from 'store/entities/payroll/payrollSetup/action'
import Spinner from 'components/__new/common/Spinner'
import usePayrollEssentials from 'hooks/usePayrollEssentials'


const BenefitAssignment = () => {
	const {useSelector,dispatch, history} = usePayrollEssentials()
	const [selected, setSelected] = useState([]);

  const [showAll, setShowAll] = useState(false);
  const [limit, setLimit] = useState(5);
	const {benefitDetails: breakdown, createBenefitsLoading: loading} = useSelector(state => state.entities.payrollSetup)

  const { getAllGroupsLoading } = useSelector(state => state.entities.groups)
  const { employeesLoading } = useSelector(state => state.entities.employees)

  const isLoading = getAllGroupsLoading || employeesLoading
	const [param, setParam] = useState('Groups');


	const isGroups = param === 'Groups'

    const handleChange = (e) => {
		setSelected([])
		setParam(e.target.value)
    }

	const onProceed = () => {
        dispatch(createBenefits({...breakdown, pay_group_id: selected}))
        // .then(() => history.push('/payroll-configuration/benefits'))
    }

    const toggleLoadAll = () => {
      setLimit(showAll ? 5 : 9999)
      setShowAll(!showAll)
    }

      const onSkip = () => {
      dispatch(createBenefits(breakdown)).then(() => history.push('/payroll-configuration/benefits'))
    }

	useEffect(() => {
	if(!breakdown) {
		history.push("/payroll-configuration/benefits")
	}
	})

  return (
      <div className="w-full">
        {loading ? <Spinner message="Configuring" />:
        <>
        <div className="border-b flex-btw items-start flex-wrap lg:flex-nowrap pb-5">
            <div className="w-full lg:w-2/4 mb-5 lg:mb-0">
                <p className="mb-1 font-medium prl-bold">Assign "{breakdown?.name}" Benefit</p>
                <p className="mb-1 text-xs lt-gray">Assign benefits to Employees or Groups</p>
            </div>
            <div className="w-full lg:w-2/4 flex items-center lg:justify-end">
                <button disabled={isLoading} onClick={onSkip} className="btn btn-md btn-white bg-white mr-4 lg:mr-6">Skip</button>
                <button disabled={isLoading || !selected?.length} onClick={onProceed} className="btn btn-md btn-ep-primary">Save</button>
            </div>
        </div>

        <div className="flex-btw items-center bg-[#f9fafb] p-2 mt-5 lg:mt-0">
          <div className="w-max lg:w-2/4 flex items-center">
            <p className="mb-0 whitespace-nowrap">Assign to: </p>&nbsp;&nbsp;
            <div className="w-max">
                <select disabled defaultValue="Groups" onChange={handleChange} className="form-input">
                {/* <option value="Employees">Employees &nbsp;&nbsp;</option> */}
                <option value="Groups">Pay Groups &nbsp;&nbsp;&nbsp;</option>
                </select> 
            </div>
          </div>
          <div className="w-max lg:w-2/4 flex lg:justify-end">
            {isGroups ?   <button disabled={isLoading} onClick={toggleLoadAll} className="flex items-center btn btn-sm btn-transparent-primary">
                  <SyncIcon className='mr-2 text-sm' />  {showAll ? "See fewer" : "Load all Pay Groups"}
              </button> :  <button disabled={isLoading} onClick={toggleLoadAll} className="flex items-center btn btn-sm btn-transparent-primary">
                  <SyncIcon className='mr-2 text-sm' />  {showAll ? "See fewer" : "Load all employees"}
              </button>}
          </div>
        </div>
        {isGroups ? <CompactGroups selected={selected} setSelected={setSelected} showAll={showAll} limit={limit} setLimit={setLimit} /> : 
        <CompactEmployees selected={selected} setSelected={setSelected} showAll={showAll} limit={limit} setLimit={setLimit} /> }
        </>}
    </div>
  )
}

export default BenefitAssignment